module.exports = __webpack_public_path__ + "img/5-1.99bd90e0.svg";